import { Component } from 'react';
import { getAllItems } from '../../services/JsonFetchService.js';
import PaginatedItems from '../paginatedItems/PaginatedItems';
import NewsItems from './NewsItems';
import './PaginatedNews.css';

const itemsPerPage = 3;
const sumNumbers = itemsPerPage * (itemsPerPage + 1) / 2;
const pageParameter = 'page';

class PaginatedNews extends Component {

    _isMounted = false;

    constructor() {
        super();
        this.state = {
            newsItems: [],
            page: 0
        };
        this.setPage = this.setPage.bind(this)
    }

    setPageByUrl() {
        const searchString = window.location.search;         //?page=17
        const searchParams = new URLSearchParams(searchString);
        const page = searchParams.has(pageParameter) ? searchParams.get(pageParameter) - 1 : 0;
        this.setPage(page);
    }

    setPage(page) {
        this.setState({ page });
    }

    async componentDidMount() {
        window.onpopstate = () => {
            if (this._isMounted) {
                this.setPageByUrl();
            }
        }

        const newsItems = await getAllItems('/news/newsItems.json');
        if (newsItems.length > 0) {
            this.setState({ newsItems });
            this.setPageByUrl();
            this._isMounted = true;
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <div className="news">
                <h2 className="news__title">Новости</h2>
                <div className="container">
                    <div className="row">
                        {this.state.newsItems.length !== 0 &&
                            <PaginatedItems
                                items={this.state.newsItems}
                                func={NewsItems}
                                itemsPerPage={itemsPerPage}
                                sumNumbers={sumNumbers}
                                page={this.state.page}
                                setPage={this.setPage} />}
                    </div>
                </div>
            </div>
        )
    }
}

export default PaginatedNews;
